<script>
const store = {
    page: null,
    calculation: {total: 0},
    calculationName: "",
    liveFormulas: [],
    pageVariables: [],
    colorizedQuestions: [],
    rdyToSend: {},
    modalOpen: false,
    publicId: null,
    readOnly: false,
    debug: {
        ignoreRdyToSend: false
    }
}

export default {
    name: 'Store',
    data: store,
    computed: {
        isCalculationSaved: function() {
            if(this.calculationName.length > 0) {
                return true
            }

            return false
        },
        axiosBase: function() {
            return "eventcalculator/"+this.publicId+'/'
        },
        preventSendData: function() {
            if(!this.$store.readOnly) {
                return false
            }
            
            return true
        }
    },
    watch: {
        "page.changeWarningEnabled": function() {
            // if(!this.$store.readOnlyCode) {
            //     if(value) {
            //         this.$store.readOnly = true
            //     } else {
            //         this.$store.readOnly = false
            //     }
            // }
        }
    }
}
</script>